// src/utils/whatsapp.js

export const openWhatsApp = (itemCode) => {
  try {
    const phoneNumber = "94710881919"; // Without the + sign
    const message = `Hello! I'm interested in item code: ${itemCode}. Could you please provide more details?`;
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);
    
    // Detect if user is on mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // WhatsApp Click-to-Chat API
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    console.log("Opening WhatsApp with URL:", whatsappURL); // Debug log
    
    if (isMobile) {
      // On mobile, open directly
      window.open(whatsappURL, "_blank");
    } else {
      // On desktop, open and provide fallback instructions
      const opened = window.open(whatsappURL, "_blank");
      
      // If popup was blocked or didn't open
      if (!opened) {
        alert(`Please allow popups or manually open WhatsApp and message +94 71 088 1919 with item code: ${itemCode}`);
      }
    }
  } catch (error) {
    console.error("Error opening WhatsApp:", error);
    alert(`Could not open WhatsApp. Please message +94 71 088 1919 directly with item code: ${itemCode}`);
  }
};